export const getSortQueryString = (sortParamArray: string[]) => {
  if (sortParamArray.length === 0) {
    return null;
  }

  return `sort=${sortParamArray.join(',')}`;
};
